import React from 'react';
import styled, { css } from 'styled-components';
import DropDown from '@ubeya/shared-web/components/DropDown';
import BaseCircleIcon from '@ubeya/shared-web/components/CircleIcon';
import { ReactComponent as MoreIcon } from '@ubeya/shared-web/assets/BookingBoard/menu.svg';
import HelpDeskActionsMenu from './HelpDeskActionsMenu';

const MENU_WIDTH_DEFAULT = 320;
const MENU_WIDTH_CUSTOM_PICKER = 630;

const MenuTrigger = styled(BaseCircleIcon)`
  width: 24px;
  height: 24px;
  padding: 0;
  ${({ $withBackground, theme }) => $withBackground && `background: ${theme.colors.white};`}

  ${({ $isListItemActions }) =>
    $isListItemActions &&
    css`
      :hover {
        background: white;
      }
      border: 1px solid ${({ theme }) => theme.colors.grey1};
    `}


  svg {
    width: 18px;
    height: 18px;
  }
`;

const HelpDeskTicketActionsDropdown = ({
  className,
  ticket,
  isLoading,
  isMenuCustomPickerVisible,
  onCustomPickerVisibleChange,
  onResolve,
  resolveDisabled,
  onSnooze,
  onUnsnooze,
  onUnresolve,
  onReopen,
  onCloseTicketRequest,
  onTogglePending,
  isUnread,
  onToggleRead,
  onOpenChange,
  triggerHasBackground = false,
  dataTestId,
  isListItemActions = false
}) => {
  const menuWidth = isMenuCustomPickerVisible ? MENU_WIDTH_CUSTOM_PICKER : MENU_WIDTH_DEFAULT;

  return (
    <DropDown
      className={className}
      showArrow={false}
      usePortal
      openFromRight={!isListItemActions}
      isDisabled={isLoading}
      menuMaxWidth={menuWidth}
      menuOffset={{ top: 5 }}
      portalStyle={{ gap: 0 }}
      onOpenChange={onOpenChange}
      renderValue={({ isOpen }) => (
        <MenuTrigger
          $isListItemActions={isListItemActions}
          icon={MoreIcon}
          isActive={isOpen}
          $withBackground={triggerHasBackground}
          dataTestId={dataTestId}
        />
      )}>
      <HelpDeskActionsMenu
        ticket={ticket}
        onResolve={onResolve}
        resolveDisabled={resolveDisabled}
        onSnooze={onSnooze}
        onUnsnooze={onUnsnooze}
        onUnresolve={onUnresolve}
        onReopen={onReopen}
        onCloseTicketRequest={onCloseTicketRequest}
        onTogglePending={onTogglePending}
        isUnread={isUnread}
        onToggleRead={onToggleRead}
        onCustomPickerVisibleChange={onCustomPickerVisibleChange}
      />
    </DropDown>
  );
};

export default HelpDeskTicketActionsDropdown;
